import ServiceDetailPage from "../../ones/ServiceDetailPage";
import Footer from "../../ones/Footer";
import image1 from "../../assets/adventure.jpg";
import image2 from "../../assets/banner6.jpg";
import image3 from "../../assets/trips.jpg";

export default function ServiceMaize() {
  return (
    <>
      <ServiceDetailPage
        label="Adventure"
        title="Classic Tanzania Adventure"
        subtitle="A balanced itinerary blending wildlife game drives, local culture, and scenic landscapes for travelers who want a complete first Tanzania experience."
        overview="This journey combines national parks, community encounters, and comfortable lodges into one smooth route. It is ideal for couples, families, and small groups seeking variety without rushing the trip pace."
        images={[
          {
            src: image1,
            alt: "Adventure itinerary route",
            captionTitle: "Multi-Experience Journey",
            captionText: "Wildlife, culture, and scenery in one curated route.",
          },
          {
            src: image2,
            alt: "Safari landscape",
            captionTitle: "Balanced Travel Pace",
            captionText: "Designed to avoid overpacking each day with long drives.",
          },
          {
            src: image3,
            alt: "Travel moments",
            captionTitle: "Flexible Itinerary",
            captionText: "Adjustable activities based on your interests and season.",
          },
        ]}
        highlights={[
          "Combined wildlife, nature, and cultural touchpoints.",
          "Private guide and vehicle with flexible daily planning.",
          "Comfort-led route sequencing from arrival to departure.",
        ]}
        metrics={[
          { value: "5-10 Days", label: "Typical trip duration" },
          { value: "Private", label: "Guide and vehicle format" },
          { value: "Flexible", label: "Activity customization level" },
        ]}
      />
      <Footer />
    </>
  );
}
